export const desktopNavConfig = [
  {
    title: '시설물 지도',
    path: '/map',
  },
  {
    title: '시설물 현황',
    path: '/facility',
  },
  {
    title: '점검 현황',
    path: '/inspection',
  },
  {
    title: '종류 관리',
    path: '/category',
  },
];

export const desktopManagerNavConfig = [
  {
    title: '시설물 지도',
    path: '/map',
  },
  {
    title: '시설물 현황',
    path: '/facility',
  },
  {
    title: '점검 현황',
    path: '/inspection',
  },
  {
    title: '종류 관리',
    path: '/category',
  },
  {
    title: '이용자 관리',
    path: '/users',
  },
];

export const mobileNavConfig = [
  {
    title: '시설물 지도',
    path: '/map',
  },
  {
    title: '종류 관리',
    path: '/category',
  },
  {
    title: '내 계정',
    path: '/users/me',
  },
];

export const mobileManagerNavConfig = [
  {
    title: '시설물 지도',
    path: '/map',
  },
  {
    title: '종류 관리',
    path: '/category',
  },
  {
    title: '이용자 관리',
    path: '/users',
  },
  {
    title: '내 계정',
    path: '/users/me',
  },
];
